import { render, staticRenderFns } from "./AlertFrame.vue?vue&type=template&id=44c26a9b&scoped=true&"
import script from "./AlertFrame.vue?vue&type=script&lang=js&"
export * from "./AlertFrame.vue?vue&type=script&lang=js&"
import style0 from "./AlertFrame.vue?vue&type=style&index=0&id=44c26a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c26a9b",
  null
  
)

export default component.exports